// Payment method related localization mappings
const paymentMethodDialog = {
  "payment.method.dialog.title": "Payment Method",
  "payment.method.dialog.description": "Select a payment method or add a new one",
  "payment.method.no-methods": "You don't have any saved payment methods",
  "payment.method.add.new": "Add new payment method",
  "payment.method.add.new-title": "Enter your card details",
  "view-more": "View more",
};

const paymentMethodErrors = {
  "payment.method.error.stripe.not-loaded": "Stripe not loaded",
  "payment.method.error.missing-ids": "Missing subscription ID or payment method ID",
  "payment.method.error.unknown": "Unknown error",
};

export const paymentMethod = {
  ...paymentMethodDialog,
  ...paymentMethodErrors,
};
